module.exports = __webpack_public_path__ + "media/images/bitcoin-lightning-b000587ef4d7ab005277a474f9a3b153.svg";